export default __webpack_public_path__ + "static/insurance-background-dark-c745ff79779a7171bb7fa4ed950f8571.webp";